import {
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  githubAuthApiRef,
} from '@backstage/core-plugin-api';
import { mergeOpsApiRef } from './MergeOpsApi';
import { MergeOpsClient } from './MergeOpsClient';

export const mergeOpsApiFactory = createApiFactory({
  api: mergeOpsApiRef,
  deps: {
    discoveryApi: discoveryApiRef,
    fetchApi: fetchApiRef,
    // The signed-in user's GitHub identity — approve/merge run as the user.
    githubAuth: githubAuthApiRef,
  },
  factory: deps => new MergeOpsClient(deps),
});
